import { Box, Typography } from "@mui/material";
import { purple } from "@mui/material/colors";
import { useRouteError } from "react-router-dom";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <div id="error-page">
      <Typography
        variant="h6"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        Oops! This content isn't available at the moment{" "}
      </Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography variant="h1">
          {error.status} {error.statusText || error.message}
        </Typography>
      </Box>
    </div>
  );
}
